<template>
  <FormKit
    v-model="countryIso3Value"
    type="CountryDropdown"
    name="countryIso3"
    :label="countryIso3?.label ?? $t('form.label.country')"
    validation="required"
    :options="PERMITTED_COUNTRIES"
    value-key="shortName"
    :all-countries="countryIso3?.allCountries"
    :disabled="countryIso3?.disabled"/>
  <FormKit
    type="TextPatternInput"
    name="postalCode"
    :label="postalCode?.label ?? $t('form.label.postal_code')"
    :validation="[
      ['required'],
      ['matches', countryZipRegexp],
    ]"
    :validation-messages="{
      matches: $t('validation.invalid_zip'),
    }"
    :disabled="postalCode?.disabled"/>
  <FormKit
    type="TextPatternInput"
    name="city"
    :label="city?.label ?? $t('form.label.city')"
    :pattern="CityFormKitRule.pattern"
    :validation="CityFormKitRule.validation"
    :disabled="city?.disabled"/>
  <FormKit
    type="TextPatternInput"
    name="addressLine1"
    :label="addressLine1?.label ?? $t('form.label.address_line_1')"
    :pattern="AddressLineFormKitRule.pattern"
    :validation="AddressLineFormKitRule.validation"
    :disabled="addressLine1?.disabled"/>
  <FormKit
    type="TextPatternInput"
    name="addressLine2"
    :label="addressLine2?.label ?? $t('form.label.address_line_2')"
    :pattern="AddressLineFormKitRule.pattern"
    :disabled="addressLine2?.disabled"/>
</template>

<script setup lang="ts">
import { PERMITTED_COUNTRIES } from '@/constants/countries';
import { AddressLineFormKitRule } from '@/rules/formkit-rules/Address';
import { CityFormKitRule } from '@/rules/formkit-rules/City';
import { useOnboardingCommonStore } from '@/stores/onboarding/OnboardingCommon';

interface AddressFieldProps {
  label?: string;
  disabled?: boolean;
}

defineProps<{
  countryIso3?: AddressFieldProps & { allCountries?: boolean };
  postalCode?: AddressFieldProps;
  city?: AddressFieldProps;
  addressLine1?: AddressFieldProps;
  addressLine2?: AddressFieldProps;
}>();

const { useCountryZipRegexp } = useOnboardingCommonStore();

const [countryIso3Value, countryZipRegexp] = useCountryZipRegexp();
</script>
